























































































































































































import { Component, Inject, Mixins, Prop } from "vue-property-decorator";

// Types
import {
  ILegacyInvoicesProviderData,
  ILegacyInvoicesProviderMethods
} from "@/models/providers/legacyInvoices";
import Context from "@/mixins/context";
import { mapGetters } from "vuex";
import { IInvoice } from "@/models/invoices";
import { Contexts } from "@/models/contexts";
import store from "@/store";

@Component({
  components: {
    "relative-invoice-status": () =>
      import("@/components/app/global/invoices/relativeInvoiceStatus.vue")
  },
  computed: {
    ...mapGetters({
      isMultibrand: "brand/isMultibrand"
    })
  }
})
export default class LegacyInvoicesTable extends Mixins(Context) {
  // Inject

  @Inject({ from: "legacyInvoicesProviderData" })
  public readonly $legacyInvoicesProviderData!: () => ILegacyInvoicesProviderData;

  @Inject({ from: "legacyInvoicesProviderMethods" })
  public readonly legacyInvMethods!: ILegacyInvoicesProviderMethods;

  // Props

  @Prop({ default: "router-link" })
  public rowTag!: string;

  @Prop({
    default: () => (invoice: IInvoice) => ({
      to: {
        name:
          store.state.context === Contexts.ADMIN
            ? "adminClientLegacyInvoice"
            : "clientLegacyInvoice",
        params: {
          invoiceId: invoice.id,
          clientId: invoice.client_id
        }
      }
    })
  })
  public rowProps!: (invoice: IInvoice) => Record<string, any>;

  @Prop({ default: () => () => ({}) })
  public rowEvents!: (invoice: IInvoice) => Record<string, Function>;

  @Prop({ default: true })
  public showClientCell!: boolean;

  // Computed

  public get legacyInvData() {
    return this.$legacyInvoicesProviderData();
  }

  public isMultibrand!: boolean;
}
